export var KeyEvent;
(function (KeyEvent) {
    KeyEvent["ArrowUp"] = "ArrowUp";
    KeyEvent["ArrowDown"] = "ArrowDown";
    KeyEvent["Enter"] = "Enter";
})(KeyEvent || (KeyEvent = {}));
